export default "__VITE_ASSET__bdff641d__"